import { render, staticRenderFns } from "./DashboardLanguageRepetitionsNotification.vue?vue&type=template&id=0baed3a5&scoped=true&"
import script from "./DashboardLanguageRepetitionsNotification.vue?vue&type=script&lang=js&"
export * from "./DashboardLanguageRepetitionsNotification.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLanguageRepetitionsNotification.vue?vue&type=style&index=0&id=0baed3a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baed3a5",
  null
  
)

/* custom blocks */
import block0 from "./DashboardLanguageRepetitionsNotification.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports